import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import { useTranslation } from 'react-i18next';

import image_1 from '../../sources/Graph/CustomizedService_1.png'
import image_2 from '../../sources/Graph/CustomizedService_2.png'
import image_3 from '../../sources/Graph/CustomizedService_3.png'
import image_4 from '../../sources/Graph/CustomizedService_4.png'
import immersiveImage1 from '../../sources/Graph/SCR-20260819-npmp.jpeg'
import immersiveImage2 from '../../sources/Graph/SCR-20260819-nqey.jpeg'
import immersiveImage3 from '../../sources/Graph/SCR-20260819-nqql.jpeg'
import immersiveImage4 from '../../sources/Graph/SCR-20260819-nqvj.jpeg'
import immersiveImage5 from '../../sources/Graph/SCR-20260819-nrax.jpeg'
import immersiveImage6 from '../../sources/Graph/SCR-20260819-nrft.png'
import immersiveImage7 from '../../sources/Graph/SCR-20260819-nrri.jpeg'
import immersiveImage8 from '../../sources/Graph/SCR-20260819-nrwh.jpeg'
import immersiveImage9 from '../../sources/Graph/SCR-20260819-nsdd.jpeg'

const immersiveImages = [
  immersiveImage1,
  immersiveImage2,
  immersiveImage3,
  immersiveImage4,
  immersiveImage5,
  immersiveImage6,
  immersiveImage7,
  immersiveImage8,
  immersiveImage9,
];

function Gallery_CustomizedService() {
  const { t } = useTranslation();
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  return (
    <Box width="100%" align='center'>
      <Typography fontFamily="Noto Sans TC" textAlign="center" fontSize="36px" fontWeight={600} fontStyle="normal" color='#7DC4A2' py={3} sx={{ textShadow: '0px 4px 8px rgba(0, 0, 0, 0.15)', lineHeight: '100%', position: 'relative'}}>
        {t('CustomizedService.title')}
      </Typography>
      <Typography fontFamily="Noto Sans TC" textAlign="center" fontSize="24px" fontWeight={400} color="#99918C" py={3}>
        {t('CustomizedService.text')}
      </Typography>

      <Grid container spacing={2} sx={{ p: 2, borderRadius: '8px' }}>
        <Grid item xs={12} md={4} sx={{ aspectRatio: '1/1' }}>
          <img
            src={image_1}
            alt="image_1"
            style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
          />
        </Grid>
        <Grid item xs={12} md={8} container spacing={2}>
          <Grid item xs={12} sx={{ aspectRatio: '2/1' }}>
            <img
              src={image_2}
              alt="image_2"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
            />
          </Grid>
          <Grid item xs={6} sx={{ aspectRatio: '1/1' }}>
            <img
              src={image_3}
              alt="image_3"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
            />
          </Grid>
          <Grid item xs={6} sx={{ aspectRatio: '1/1' }}>
            <img
              src={image_4}
              alt="image_4"
              style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '4px' }}
            />
          </Grid>
        </Grid>
      </Grid>

      <Box sx={{ mt: { xs: 3, md: 5 } }}>
        <Button
          type="button"
          aria-expanded={isGalleryOpen}
          aria-controls="immersive-virtual-gallery"
          onClick={() => setIsGalleryOpen((currentState) => !currentState)}
          sx={{
            minWidth: 0,
            px: 2,
            py: 1,
            color: '#5EAA88',
            fontFamily: 'Noto Sans TC',
            fontSize: { xs: '16px', md: '18px' },
            fontWeight: 600,
            textTransform: 'none',
            display: 'inline-flex',
            flexDirection: 'column',
            backgroundColor: 'transparent',
            transition: 'color 0.2s ease, opacity 0.2s ease',
            '&:hover': {
              color: '#459873',
              backgroundColor: 'transparent',
              opacity: 0.85,
            },
          }}
        >
          <Box component="span">
            {isGalleryOpen ? t('CustomizedService.hideGallery') : t('CustomizedService.showGallery')}
          </Box>
          <Box
            component="span"
            aria-hidden="true"
            sx={{
              mt: 0.75,
              width: '24px',
              height: '22px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              transform: isGalleryOpen ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s ease',
            }}
          >
            {[0, 1].map((arrowIndex) => (
              <Box
                key={arrowIndex}
                component="span"
                sx={{
                  width: '12px',
                  height: '12px',
                  mt: arrowIndex === 1 ? '-5px' : 0,
                  borderRight: '2px solid currentColor',
                  borderBottom: '2px solid currentColor',
                  transform: 'rotate(45deg)',
                }}
              />
            ))}
          </Box>
        </Button>

        <Collapse in={isGalleryOpen} timeout={450} unmountOnExit>
          <Box
            id="immersive-virtual-gallery"
            role="region"
            aria-label={t('CustomizedService.galleryLabel')}
            sx={{
              mt: { xs: 3, md: 5 },
              px: { xs: 2, md: 2 },
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', md: 'repeat(3, minmax(0, 1fr))' },
              gap: { xs: 2, md: 3 },
            }}
          >
            {immersiveImages.map((image, index) => (
              <Box
                key={image}
                component="img"
                src={image}
                alt={`${t('CustomizedService.imageAlt')} ${index + 1}`}
                loading="lazy"
                sx={{
                  width: '100%',
                  aspectRatio: '4 / 3',
                  display: 'block',
                  objectFit: 'cover',
                  borderRadius: { xs: '6px', md: '10px' },
                  boxShadow: '0 8px 24px rgba(78, 67, 60, 0.12)',
                }}
              />
            ))}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
}

export default Gallery_CustomizedService;
